import type { Action } from 'redux';
import type { GetGoogleAuthenticationUrlPayload } from '../GoogleMarketingPlatform.types';
import { ReduxAsyncAction } from '../../../../../services/ReduxAsyncAction';
import dash_api from '../../../../../../main/support/dash_api';

const GetGoogleAuthenticationUrl = new ReduxAsyncAction<
  'GET_GOOGLE_AUTHENTICATION_URL',
  { scope: String; machineName: String },
  GetGoogleAuthenticationUrlPayload
>('GET_GOOGLE_AUTHENTICATION_URL');
GetGoogleAuthenticationUrl.registerRequest(({ scope, machineName }) => {
  return dash_api.get(`/v1/google/auth-url?scope=${scope}&machine_name=${machineName}`).then(({ data }) => {
    return data;
  });
});
export const GET_GOOGLE_AUTHENTICATION_URL = GetGoogleAuthenticationUrl.actionNamespaceConstants;
export const getGoogleAuthenticationUrl = GetGoogleAuthenticationUrl.request;

export type GetGoogleAuthenticationUrlAction = Action<typeof GET_GOOGLE_AUTHENTICATION_URL.response> & {
  data: GetGoogleAuthenticationUrlPayload;
};
